import schoolApi from './api/schoolApi';

export const SCHOOL_INSERT = 'school/INSERT';
export const SCHOOL_LIST = 'school/LIST';

const initialState = {
	data: null,
}

export default (state = initialState, action) => {
	switch (action.type) {
		case SCHOOL_LIST:
			return {
				...state,
				data: action.payload
			};
		default:
			return state;

	}
};

export const schoolInsert = (payload) => {
	return dispatch => {
		return schoolApi.SchoolInsert(payload).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const schoolUpdate = (payload, id) => {
	return dispatch => {
		return schoolApi.SchoolUpdate(payload, id).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const schoolList = () => {
	return dispatch => {
		return schoolApi.SchoolList().then(data => {
			dispatch({
				type: SCHOOL_LIST,
				payload: data
			});
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

export const schoolDelete = (id) => {
	return dispatch => {
		return schoolApi.SchoolDelete(id).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	};
};

//Lazy...

export const averageScore = (schoolId, schoolYear, name) => {
	return dispatch => {
		return schoolApi.AverageScore(schoolId, schoolYear, name).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	}
}

export const browseCount = (year, month, day) => {
	return dispatch => {
		return schoolApi.BrowseCount(year, month, day).then(data => {
			return data;
		}).catch(error => {
			throw (error);
		});
	}
}